export const DEFAULT_ESTATE_MAPPING_COPY = {
  title: "Estate Mapping",
  client_name: "",
  loading: "Cargando...",
  invalid_link: "El enlace no es valido o ha expirado.",
  step: "Paso",
  of: "de",
  welcome: {
    title: "Hola %{name}, bienvenido a tu mapa patrimonial",
    body: "Este cuestionario te permite registrar la informacion de tu patrimonio de forma ordenada, para que Bulltick cuente con una vision completa y precisa.",
    steps: [
      "Selecciona las secciones que aplican a tu situacion",
      "Registra los detalles de cada elemento",
      "Revisa la informacion y enviala a Bulltick",
    ],
    start: "Comenzar",
    pause: "Puedes pausar el proceso y retomarlo en cualquier momento.",
  },
  selection: {
    title: "¿Qué incluye tu patrimonio?",
    body: "Selecciona unicamente las secciones que aplican. Podras agregar mas adelante si lo necesitas.",
    none: "Ninguna seccion seleccionada",
    singular: "seccion seleccionada",
    plural: "secciones seleccionadas",
  },
  review: {
    title: "Revisa tu información",
    body: "Antes de enviar, verifica que los datos registrados sean correctos. Puedes editar cualquier elemento o agregar secciones que hayan quedado pendientes.",
    sections: "Secciones",
    total_records: "Registros totales",
    status: "Estado",
    ready: "Listo",
    record: "registro",
    records: "registros",
    omitted: "Seccion omitida, sin registros.",
    add_unselected: "Agregar una seccion que no seleccionaste",
    assets: "Activos",
    liabilities: "Pasivos",
    structures_and_family: "Estructuras y Relaciones Familiares",
    family_preview: "Vista previa - Relaciones Familiares",
    wealth_map_preview: "Vista previa - Wealth Map",
    notice: "Al enviar, Bulltick recibira esta informacion para su analisis. Si posteriormente requieres realizar cambios, contacta a tu equipo de Bulltick.",
    submit: "Enviar a Bulltick",
  },
  form: {
    new_record: "Nuevo registro",
    edit_record: "Editar registro",
    back_to_review: "Regresar a la revision",
    back_to_list: "Regresar a la lista",
    required_error: "Campo obligatorio",
    tooltip_label: "Más información",
    select_placeholder: "Seleccionar...",
    other_currency_placeholder: "Ingresa el codigo de moneda",
    other_role_placeholder: "Especifica el rol",
    holder_other_option: "Otro",
    link_new_structure: "Vincular a una nueva estructura",
    link_new_liability: "Vincular a un nuevo pasivo",
    holder_other_placeholder: "Ingresa el nombre del titular",
    linked_structure_placeholder: "Nombre de la nueva estructura",
    linked_liability_placeholder: "Nombre del nuevo pasivo",
    choose_asset_type: "Elige el tipo de activo",
    select_asset: "Selecciona un activo",
    add_linked_structure: "Agregar estructura",
    notes: "Notas",
    notes_placeholder: "Agrega notas relevantes",
    documents: "Documentos",
    documents_description: "Adjuntar documentos si aplica",
    upload_document: "Subir documento",
    uploading_document: "Subiendo...",
    drop_documents: "O arrastra los archivos aquí",
    no_documents: "No hay documentos adjuntos.",
    documents_unavailable: "Guarda el enlace de estate mapping para poder subir documentos.",
  },
  done: {
    title: "Informacion enviada",
    body: "Bulltick revisara tu mapa patrimonial y te contactara para los siguientes pasos.",
    review: "Revisar mi información",
  },
  buttons: {
    continue: "Continuar",
    previous: "Anterior",
    skip_section: "Omitir seccion",
    cancel: "Cancelar",
    save_record: "Guardar registro",
    edit: "Editar",
    delete: "Eliminar",
  },
  list: {
    empty_detail: "Registro sin detalles",
    empty_section: "Si no cuentas con elementos en esta seccion, puedes omitirla y continuar.",
    no_name: "Sin nombre",
  },
  tree: {
    fiscal_residence: "Res. fiscal",
  },
  pillars: {
    "Activos": "Activos",
    "Pasivos": "Pasivos",
    "Estructura Patrimonial": "Estructura Patrimonial",
  },
  sections: {},
  fields: {},
  placeholders: {},
  tooltips: {},
  option_values: {},
};

export const getEstateMappingCopy = (internalization = {}) => ({
  ...DEFAULT_ESTATE_MAPPING_COPY,
  ...(internalization.estate_mapping || {}),
  welcome: { ...DEFAULT_ESTATE_MAPPING_COPY.welcome, ...((internalization.estate_mapping || {}).welcome || {}) },
  selection: { ...DEFAULT_ESTATE_MAPPING_COPY.selection, ...((internalization.estate_mapping || {}).selection || {}) },
  review: { ...DEFAULT_ESTATE_MAPPING_COPY.review, ...((internalization.estate_mapping || {}).review || {}) },
  form: { ...DEFAULT_ESTATE_MAPPING_COPY.form, ...((internalization.estate_mapping || {}).form || {}) },
  done: { ...DEFAULT_ESTATE_MAPPING_COPY.done, ...((internalization.estate_mapping || {}).done || {}) },
  buttons: { ...DEFAULT_ESTATE_MAPPING_COPY.buttons, ...((internalization.estate_mapping || {}).buttons || {}) },
  list: { ...DEFAULT_ESTATE_MAPPING_COPY.list, ...((internalization.estate_mapping || {}).list || {}) },
  tree: { ...DEFAULT_ESTATE_MAPPING_COPY.tree, ...((internalization.estate_mapping || {}).tree || {}) },
  pillars: { ...DEFAULT_ESTATE_MAPPING_COPY.pillars, ...((internalization.estate_mapping || {}).pillars || {}) },
  sections: { ...DEFAULT_ESTATE_MAPPING_COPY.sections, ...((internalization.estate_mapping || {}).sections || {}) },
  fields: { ...DEFAULT_ESTATE_MAPPING_COPY.fields, ...((internalization.estate_mapping || {}).fields || {}) },
  placeholders: { ...DEFAULT_ESTATE_MAPPING_COPY.placeholders, ...((internalization.estate_mapping || {}).placeholders || {}) },
  tooltips: { ...DEFAULT_ESTATE_MAPPING_COPY.tooltips, ...((internalization.estate_mapping || {}).tooltips || {}) },
  option_values: { ...DEFAULT_ESTATE_MAPPING_COPY.option_values, ...((internalization.estate_mapping || {}).option_values || {}) },
});
